import { Show } from "shared/components";
import { AddUnits } from ".";
import Drawer from "react-modern-drawer";
import { useMedia } from "shared/providers";
import { Property } from "shared/types";
import { Unit } from "types/landlord/address";

export const AddUnitDrawer = ({
  open,
  newUnitName,
  selectedProperty,
  onClose,
  onSuccess
}: {
  open: boolean;
  newUnitName?: string;
  selectedProperty?: Property;
  onClose?: () => void;
  onSuccess?: (newUnit: Unit) => void;
}) => {
  const { isMobile } = useMedia();

  return (
    <Drawer
      zIndex={15}
      className="rounded-l-lg"
      direction="right"
      onClose={onClose}
      open={open}
      size={isMobile ? 380 : 640}
    >
      <Show if={open}>
        <AddUnits
          isDrawerContent
          onClose={onClose}
          onSuccess={onSuccess}
          selectedProperty={selectedProperty}
          newUnitName={newUnitName}
        />
      </Show>
    </Drawer>
  );
};
